export const getImports = state => state.search.imports;
export const isFetching = state => state.search.isFetching;

export const getMeta = state => state.search.meta;
export const getCurrentPage = state => getMeta(state).currentPage;
export const getTodalPages = state => getMeta(state).totalPages;
